import React, { FC, useState, type PropsWithChildren } from "react";
import AccordionSection from "./AccordionSection";
import { Switch } from "../../../../../components";
import type { ProfileLinkConfig } from "../../../../../client";

const SettingRow: FC<PropsWithChildren> = ({ children }) => {
  return (
    <div className="flex items-center justify-between gap-2">{children}</div>
  );
};

const SettingText: FC<PropsWithChildren> = ({ children }) => {
  return <p className="text-gray-9 text-sm font-medium grow">{children}</p>;
};

interface LinkSettingsLinkSettingsProps {
  disabled?: boolean;
  linkConfig?: ProfileLinkConfig;
  onUpdate: (payload: Partial<ProfileLinkConfig>) => void;
}

const LinkSettingsLinkSettings: FC<LinkSettingsLinkSettingsProps> = ({
  disabled,
  linkConfig,
  onUpdate,
}) => {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <AccordionSection
      title="Link settings"
      subtitle={
        linkConfig?.allowCustomContact
          ? "Custom contact enabled"
          : "Custom contact disabled"
      }
      expanded={isExpanded}
      onToggle={() => setIsExpanded(!isExpanded)}
      hideBottomBorder={true}
    >
      <SettingRow>
        <Switch
          checked={linkConfig?.allowCustomContact}
          disabled={disabled}
          onCheckedChange={(checked) => {
            if (typeof checked !== "boolean") return;

            onUpdate({
              allowCustomContact: checked,
            });
          }}
        />
        <SettingText>Enable custom contact & logo</SettingText>
      </SettingRow>
    </AccordionSection>
  );
};

export default LinkSettingsLinkSettings;
